<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
<!--        removed a contact property-->
<!--        "<strong>{{ $_.get(activity, "payload.name") }} </strong>"-->
        <span v-html="$t('notification.contactPropRemoved', {user: $_.get(activity, 'actorUser.name'), prop: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ContactPropRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
